module.exports = __webpack_public_path__ + "a815932564174f81a09441c4a8f5f6ff.pdf";